import React from 'react'
import {motion} from 'framer-motion'

const LoadingIndicator = ({
  color = '#7a7978',
  text = 'LOADING',
}) => {
  const containerStyle: React.CSSProperties = {
    position: 'absolute',
    top: 0, right: 0, bottom: 0, left: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '0.5rem',
    padding: '1rem',
  }

  const dotStyle = {
    width: '10px',
    height: '10px',
    borderRadius: '50%',
    backgroundColor: color,
  }

  const containerVariants = {
    start: {transition: {staggerChildren: 0.2}},
    end: {transition: {staggerChildren: 0.2}},
  }

  const dotVariants = {
    start: {y: '0%'},
    end: {y: '100%'},
  }

  const dotTransition = {
    duration: 0.5,
    repeat: Infinity,
    repeatType: 'reverse' as const,
    ease: 'easeInOut' as const,
  }
  return (
    <motion.div
      style={containerStyle}
      variants={containerVariants}
      initial="start"
      animate="end"
    >
      <h2 style={{marginRight: '6px', color: color}}>{text}</h2>
      {[
        0, 1, 2,
      ].map(index => (
        <motion.span
          key={index}
          style={dotStyle}
          variants={dotVariants}
          transition={dotTransition}
        />
      ))}
    </motion.div>
  )
}

export default LoadingIndicator
